import { API_BASE_URL } from '../config/api';

const BACKEND_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

export function resolveMediaUrl(value) {
  const rawValue = typeof value === 'string' ? value.trim() : '';

  if (!rawValue) {
    return '';
  }

  if (/^https?:\/\//i.test(rawValue) || rawValue.startsWith('data:')) {
    return rawValue;
  }

  if (rawValue.startsWith('/api/') || rawValue.startsWith('/uploads/')) {
    return `${BACKEND_BASE_URL}${rawValue}`;
  }

  if (rawValue.startsWith('api/') || rawValue.startsWith('uploads/')) {
    return `${BACKEND_BASE_URL}/${rawValue}`;
  }

  return `${BACKEND_BASE_URL}/api/files/view/${encodeURIComponent(rawValue)}`;
}
